export enum SubscriptionStatusEnum {
    New = 1, 
    Active = 2, 
    Expired = 3,
    Declined = 4,
};